export default "__VITE_ASSET__DvWa7KsF__"